// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';

import {BasicPermissionsGraphQL, Permissions} from 'auth/PermissionConstants';
import {FolderType} from 'constants/FolderConstants';
import {SidepanelItemSource, SourceSummary} from 'constants/SourceConstants';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import {AccountType} from 'notebook/tfi/TFIConstants';
import {ListableItem} from 'search/SearchConstants';
import * as logging from 'util/Logging';
import {ElementDragEvent} from 'util/Types';

export const SOURCES_MIME_TYPE = 'application/vnd.benchling.sources+json';
const SOURCE_KEYS = ['id', 'name', 'url', 'permissions', 'rootFolder', 'sourceType'];

export const FILES_MIME_TYPE = 'application/vnd.benchling.files+json';
const FILE_KEYS = ['id', 'name', 'url', 'permissions', 'parentFolderId', 'source', 'type'];

export const TFI_MIME_TYPE = 'application/vnd.benchling.tfi+json';
const TFI_KEYS = ['id', 'accountId', 'name'];

const OPTIONAL_KEYS = ['type', 'parentFolderId'];

export type BenchlingDataType = typeof SOURCES_MIME_TYPE | typeof FILES_MIME_TYPE | typeof TFI_MIME_TYPE;

interface BaseBenchlingDatum {
  benchlingDataType: BenchlingDataType;
}

export interface TFIJson extends BaseBenchlingDatum {
  benchlingDataType: typeof TFI_MIME_TYPE;
  id: string;
  accountId: string;
  name: string;
  accountType: AccountType;
}

export interface FileJson extends BaseBenchlingDatum {
  benchlingDataType: typeof FILES_MIME_TYPE;
  id: string;
  isShortcut: boolean;
  name: string;
  url: string;
  permissions: Permissions | BasicPermissionsGraphQL;
  parentFolderId: string;
  source: SourceSummary;
  type: FolderType | null;
}

export type SourcesJson = (ListableItem | SidepanelItemSource) &
  BaseBenchlingDatum & {
    benchlingDataType: typeof SOURCES_MIME_TYPE;
  };

/* @package */
export type GenericBenchlingDatum<TBenchlingData extends BenchlingDataType> =
  TBenchlingData extends typeof SOURCES_MIME_TYPE
    ? Array<SourcesJson>
    : TBenchlingData extends typeof FILES_MIME_TYPE
      ? Array<FileJson>
      : TFIJson;

export default function BenchlingData(e: ElementDragEvent): {
  hasData<TBenchlingData extends BenchlingDataType>(type: TBenchlingData): boolean;
  getData<TBenchlingData extends BenchlingDataType>(
    type: TBenchlingData
  ): GenericBenchlingDatum<TBenchlingData> | null;
  setLink(name: string, absoluteURL: string): true;
  setData<TBenchlingData extends BenchlingDataType>(
    type: TBenchlingData,
    json: GenericBenchlingDatum<TBenchlingData>
  ): boolean;
  validateData<TBenchlingData extends BenchlingDataType>(
    type: TBenchlingData,
    json: GenericBenchlingDatum<TBenchlingData>
  ): boolean | undefined | void;
} {
  return {
    hasData<TBenchlingData extends BenchlingDataType>(type: TBenchlingData): boolean {
      return wyciwyp.typesContains(e.dataTransfer.types, type);
    },
    getData<TBenchlingData extends BenchlingDataType>(
      type: TBenchlingData
    ): GenericBenchlingDatum<TBenchlingData> | null {
      if ([SOURCES_MIME_TYPE, FILES_MIME_TYPE, TFI_MIME_TYPE].includes(type) && this.hasData(type)) {
        const jsonData = JSON.parse(e.dataTransfer.getData(type));
        if (this.validateData(type, jsonData)) {
          return jsonData;
        }
      }
      return null;
    },
    setLink(name: string, absoluteURL: string): true {
      e.dataTransfer.setData('text/html', $('<a>').attr('href', absoluteURL).text(name)[0].outerHTML);
      e.dataTransfer.setData('text/uri-list', absoluteURL);
      e.dataTransfer.setData('text/plain', absoluteURL);
      return true;
    },
    setData<TBenchlingData extends BenchlingDataType>(
      type: TBenchlingData,
      json: GenericBenchlingDatum<TBenchlingData>
    ): boolean {
      if (this.validateData(type, json)) {
        e.dataTransfer.setData(type, JSON.stringify(json));
        return true;
      }
      return false;
    },
    validateData<TBenchlingData extends BenchlingDataType>(
      type: TBenchlingData,
      json: GenericBenchlingDatum<TBenchlingData>
    ): boolean | undefined | void {
      function validateItem(item: TFIJson | FileJson | SourcesJson, keys: Array<string>): boolean {
        for (const key of Array.from(keys)) {
          if (!(key in item) && !OPTIONAL_KEYS.includes(key)) {
            // @ts-expect-error `object` not narrow enough for Sentry's `Extras` type
            logging.warn(`BenchlingData: missing required key '${key}' for ${type}`, {extra: json});
            return false;
          }
        }
        return true;
      }

      function validateItems(keys: Array<string>): boolean {
        // @ts-expect-error We CAN pass an object as JSON. Array.from(object) will return empty array, so this
        // statement will not die, but it also will not do any useful validation.
        for (const item of Array.from(json)) {
          if (!validateItem(item, keys)) {
            return false;
          }
        }
        return true;
      }

      switch (type) {
        case SOURCES_MIME_TYPE:
          if (validateItems(SOURCE_KEYS)) {
            return true;
          }
          break;

        case FILES_MIME_TYPE:
          if (validateItems(FILE_KEYS)) {
            return true;
          }
          break;

        case TFI_MIME_TYPE:
          if (validateItems(TFI_KEYS)) {
            return true;
          }
          break;

        default:
          logging.warn(`Unexpected type: ${type}`, {extra: {json}});
          return false;
      }
    },
  };
}
